module.exports = __webpack_public_path__ + "img/3-certifications-fs_online.png";